// test376
(376 && 0);
